import { AssessDto } from './assess.dto';
import { FinalProductDto } from './final-product.dto';
import { LossDto } from './loss.dto';
import { MachineDto } from './machine.dto';
import { ProductionOrderDto } from './production-order.dto';
import { ProductionPauseDto } from './production-pause.dto';
import { ProductionProcessDto } from './production-process.dto';
import { ProductionTimeDto } from './production-time.dto';
import { RawMaterialToUseDto } from './raw-material-to-use.dto';
import { RawMaterialDto } from './rawMaterial.dto';
import { ScrapDto } from './scrap.dto';
import { SensorValueDto } from './sensor-value.dto';
import { ShiftSessionDto } from './shift-session.dto';
import { StatusDto } from './status.dto';
import { WorkingMachinesOnProcessesDto } from './working-machines-on-processes.dto';

export class ProductionOrderProcessDto {
    id?: number;
    description!: string;
    statusId?: number;
    status?: StatusDto;
    sensorValues?: SensorValueDto[];
    productionProcess!: ProductionProcessDto;
    productionProcessId?: number;
    productionTime?: ProductionTimeDto;
    productionPauses?: ProductionPauseDto[];
    order?: number;
    rawMaterialsToUse!: RawMaterialToUseDto[];
    rawMaterialsUsed!: RawMaterialDto[];
    machine!: MachineDto | null;
    machineId?: number;
    finalProducts?: FinalProductDto[];
    assess?: AssessDto | null;
    scraps?: ScrapDto[];
    losses?: LossDto[];
    qualityControlCounter?: number;
    productionOrder?: ProductionOrderDto;
    workingMachinesOnProcesses?: WorkingMachinesOnProcessesDto[];
    shiftSessions?: ShiftSessionDto[];
}
